import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosAtheneum } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  athCoursesListRoute,
  athCourseUpdateDeleteRoute,
  createCourse,
  getOneCourse,
} from '../../utils/apiRoutes';

export const getAllCoursesAsync = createAsyncThunk(
  `${moduleName}/getAllCoursesAsync`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosAtheneum({
        method: 'GET',
        url: athCoursesListRoute(),
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getOneCourseAsync = createAsyncThunk(
  `${moduleName}/getOneCourseAsync`,
  async (id) => {
    const response = await axiosAtheneum({
      method: 'GET',
      url: getOneCourse(id),
    });
    const data = response.data;
    return data;
  }
);

export const createCourseAsync = createAsyncThunk(
  `${moduleName}/createCourseAsync`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosAtheneum({
        method: 'POST',
        url: athCoursesListRoute(),
        data: paylaod,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createOneCourseAsync = createAsyncThunk(
  `${moduleName}/createOneCourseAsync`,
  async (payload) => {
    const { _id } = payload;
    const response = await axiosAtheneum({
      method: 'GET',
      url: createCourse(_id),
    });
    const data = response.data;
    return data;
  }
);

export const updateOneCourseAsync = createAsyncThunk(
  `${moduleName}/updateOneCourseAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const { _id, bodyData } = payload;
      const response = await axiosAtheneum({
        method: 'PATCH',
        url: athCourseUpdateDeleteRoute(_id),
        data: { ...bodyData },
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteOneCourseAsync = createAsyncThunk(
  `${moduleName}/deleteOneCourseAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      console.log({ delete: payload });
      const response = await axiosAtheneum({
        method: 'DELETE',
        url: athCourseUpdateDeleteRoute(payload.id),
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const CoursesSlice = createSlice({
  name: `${moduleName}/Courses`,
  initialState: {
    loading: false,
    courses: [],
    onecourse: [],
    postcourse: null,
  },
  reducers: {},
  extraReducers: {
    [getAllCoursesAsync.pending]: (state) => {
      state.loading = true;
    },
    [getAllCoursesAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.courses = action.payload.data;
    },
    [getAllCoursesAsync.rejected]: (state) => {
      state.loading = false;
    },

    [createCourseAsync.pending]: (state) => {
      state.loading = true;
    },
    [createCourseAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.postcourse = action.payload;
    },
    [createCourseAsync.rejected]: (state) => {
      state.loading = false;
    },

    [updateOneCourseAsync.pending]: (state) => {
      state.loading = true;
    },
    [updateOneCourseAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.postcourse = action.payload;
    },
    [updateOneCourseAsync.rejected]: (state) => {
      state.loading = false;
    },

    [deleteOneCourseAsync.pending]: (state) => {
      state.loading = true;
    },
    [deleteOneCourseAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.oneprogram = action.payload;
    },
    [deleteOneCourseAsync.rejected]: (state) => {
      state.loading = false;
    },

    [getOneCourseAsync.pending]: (state) => {
      state.loading = true;
    },
    [getOneCourseAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.oneprogram = action.payload;
    },
    [getOneCourseAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default CoursesSlice.reducer;
